import { TooltipDialog } from '../../widgets'

export const GuidanceDialogs = () => (
  <TooltipDialog
    order={0}
    title="Improve Your Results"
    text="This screen shows your current state for each practice."
    secondText={'Click "Next steps" to discover some tips and hints to improve this practice.'}
    image="next-steps"
    buttonText="Next"
  />
)